import React from "react";

function Tree2Element(tree) {
  return (
    tree &&
    tree.map((node, i) =>
      React.createElement(
        node.tag,
        { key: i, ...node.attr },
        Tree2Element(node.child)
      )
    )
  );
}

export function GenIcon(data) {
  return function Icon(props) {
    const { size = "1em", color, title, className, style, ...svgProps } = props;
    return React.createElement(
      "svg",
      {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0",
        ...data.attr,
        ...svgProps,
        className,
        style: color ? { color, ...style } : style,
        height: size,
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
      },
      title && React.createElement("title", null, title),
      Tree2Element(data.child)
    );
  };
}
